import { Component } from '@angular/core';

@Component({
  selector: 'public-link-unavailable',
  templateUrl: './public-link-unavailable.component.html',
  styleUrls: ['./public-link-unavailable.component.less'],
})
export class PublicLinkUnavailableComponent {}
